/**
 * Used in V1 and V2 Intake
 */
export class Tooltip {
  constructor({ el }) {
    this.el = el
    this.view = document.querySelector(el.getAttribute('data-tooltip'))

    this.el.addEventListener('click', e => {
      this.toggle()
      this.bindEvents()
    })
  }

  toggle() {
    this.view.classList.toggle('hidden')
  }

  onClick(e) {
    let isVisible = !this.view.classList.contains('hidden')
    let didClickedOutside = !this.view.contains(e.target)
    let isNotIcon = e.target != this.el

    if (isVisible && didClickedOutside && isNotIcon) {
      this.view.classList.add('hidden')
      this.unbindEvents()
    }
  }

  onKeyDown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      this.view.classList.add('hidden')
      this.unbindEvents()
    }
  }

  bindEvents() {
    document.addEventListener('click', this.onClick.bind(this))
    document.addEventListener('keydown', this.onKeyDown.bind(this))
  }

  unbindEvents() {
    document.removeEventListener('click', this.onClick)
    document.removeEventListener('keydown', this.onKeyDown)
  }
}

// Making it compatible to use it with js rails assets
window.TelemedicineTooltip = Tooltip
